import { scrollIntoView } from "@/lib";

export const highlightError = () => {
  const errorField: HTMLElement = document.querySelector(
    `.ehqQuestionError input,.ehqQuestionError button, .ehqQuestionError textarea, .ehqQuestionError label`
  );

  errorField?.focus();
  scrollIntoView(".ehqQuestionError", { block: "center" });
};
